// @flow

import React, { Fragment } from 'react'

export default ({
  company,
  hasErrorMessage,
}: {
  company: {
    paidCustomer: {
      status: number,
    },
  },
  hasErrorMessage: boolean,
}) => {
  const paidStatus = (company.paidCustomer || {}).status
  return (
    <div className="mt40">
      {company.paidCustomer !== null ? (
        <Fragment>
          {paidStatus === 1 && (
            <div className="message-wrap is-static is-attention">
              <i className="fa fa-exclamation-circle mr5" />
              <span className="message__text">
                審査申請中です。審査完了まで今しばらくお待ちください。
              </span>
            </div>
          )}
          {paidStatus === 4 && (
            <div className="message-wrap is-static is-attention">
              <i className="fa fa-exclamation-circle mr5" />
              <span className="message__text">
                審査に通りませんでした。詳細はPaidからのメールをご確認ください。
              </span>
            </div>
          )}
          {(paidStatus === 2 || paidStatus === 3) && (
            <div className="message-wrap is-static is-done">
              <i className="fa fa-check mr5" />
              <span className="message__text">審査完了済みです。</span>
            </div>
          )}
          {hasErrorMessage && (
            <div className="message-wrap is-popup">
              <i className="fa fa-exclamation-circle mr5" />
              <span className="message__text">
                もう一度ご確認の上、必須項目に情報を入力してください。
              </span>
            </div>
          )}
        </Fragment>
      ) : null}
    </div>
  )
}
